import React from 'react';

export default class DataTableDisplayToggle extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			options: [
				10,
				25,
				50,
				100
			]
		};

		this.onChange = this.onChange.bind(this);
	}

	render() {
		var self = this;
		var buttons = this.state.options.map(function(option) {
			return (
				<button
					key={option}
					type="button"
					className={
						'btn ' + (self.props.pageLength === option ? 'active' : '')
					}
					onClick={self.onChange.bind(null, option)}
				>
					{option}
				</button>
			);
		});
		return (
			<div className="DataTableDisplayToggle">
				<span className="display">{I18n.t('admin.display')}</span>
				{buttons}
				{/*<button type="button" className={"btn " + (this.props.pageLength === "all" ? "active" : "")} onClick={this.onChange.bind(null, 'all')}>{I18n.t('admin.all')}</button>*/}
			</div>
		);
	}

	onChange(pageLength) {
		this.props.onChange({
			target: {
				name: 'pageLength',
				value: pageLength
			}
		});
	}
}
